<ng-container *ngIf="!twilioService.disabled">
    <div class="d-flex justify-content-center h-100 w-100 align-items-center" *ngIf="!twilioService.isDeviceReady">
        <div class="spinner-grow text-secondary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <ng-container *ngIf="twilioService.isOutboundCallGoingOn || twilioService.isInboundCallGoingOn">
        <ng-container *ngIf="!controllingComponent">
            <div class="d-flex w-100 flex-row">
                <ng-container [ngTemplateOutlet]="mainControls"></ng-container>
            </div>
        </ng-container>
        <ng-container *ngIf="controllingComponent">
            <div class="d-flex flex-row p-2 standalone">
                <ng-container [ngTemplateOutlet]="mainControls"></ng-container>
                <div class="align-self-center text-sm-end controls">
                    <svg-icon src="assets/images/call/window-float.svg" (click)="controllingComponent.callCenterMode = 'floating-window'"></svg-icon>
                    <svg-icon src="assets/images/call/window-inline.svg" (click)="controllingComponent.callCenterMode = 'full-screen-window'"></svg-icon>
                    <svg-icon src="assets/images/call/window-x.svg" (click)="controllingComponent.callCenterMode = 'none'"></svg-icon>
                </div>
            </div>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="(twilioService.isOutboundCallRinging || twilioService.isInboundCallRinging) && controllingComponent">
        <div class="d-flex flex-row p-2 standalone">
            <ng-container [ngTemplateOutlet]="mainControls"></ng-container>
        </div>
    </ng-container>
</ng-container>

<ng-template #mainControls>
    <svg-icon class="mt-1 me-1" src="assets/images/call/user-icon.svg"></svg-icon>
    <div>
        <h6 class="my-0 fs-sm fw-500">
            <ng-container *ngIf="(twilioService.onLineContact$$ | async); then thenContact else elseContact"></ng-container>
            <ng-template #thenContact>{{(twilioService.onLineContact$$ | async).contactFirstname}} {{(twilioService.onLineContact$$ | async).contactSurname}}</ng-template>
            <ng-template #elseContact>Unknown</ng-template>
        </h6>
        <div style="line-height: 14px;">
            <span class="call-tag {{ twilioService.callSubject$ | async }}">{{ twilioService.callSubject$ | async | capitalize }}</span>
            <span class="user-type text-capitalize">&nbsp;{{(twilioService.onLineContact$$ | async)?.accountType ?? '-'}}</span>
        </div>
    </div>

    <app-call-ai-assist class="ai-assist-bar d-none d-md-block" [compact]="true"></app-call-ai-assist>

    <div class="mt-2 flex-grow-1 text-center call-duration">
        <ng-container *ngIf="twilioService.isOutboundCallGoingOn || twilioService.isInboundCallGoingOn">
            {{twilioService.callDurationFormatted$$ | async}}
        </ng-container>
    </div>
    <a class="fs-xs align-self-center details-btn" *ngIf="(callDetails$ | async)?.orders && controllingComponent" (click)="toggleOrderDetails()">View Details</a>

    <a class="btn btn-styled btn-round --sm align-self-center btn-success me-1 pickup-btn" *ngIf="twilioService.isInboundCallRinging" (click)="pickUpInboundCall()">
        <svg-icon class="--standalone" src="assets/images/call/dialer.svg"></svg-icon>
        <span class="call-domain"
              *ngIf="twilioService.activeTwilioDomain != (store.select('domain') | async)"
        >{{ twilioService.activeTwilioDomain }}</span>
    </a>
    <a class="btn btn-styled btn-round --sm align-self-center btn-danger" (click)="twilioService.hangUpCall()">
        <svg-icon class="--standalone" src="assets/images/call/phone-icon.svg"></svg-icon>
    </a>
    <ng-container *ngIf="twilioService.isInboundCallGoingOn || twilioService.isOutboundCallGoingOn">
        <a class="btn btn-styled btn-round --sm align-self-center ms-1" *ngIf="twilioService.callState !== twilioService.CallState.ONHOLD && twilioService.callState === twilioService.CallState.ONGOING">
            <svg-icon class="--standalone hover" [src]="(twilioService.onHoldCall$ | async) === false ? 'assets/images/call/pause-call-icon.svg' : 'assets/images/call/resume-call-icon.svg'" (click)="twilioService.toggleHoldConf()"></svg-icon>
        </a>
        <a class="btn btn-styled btn-round --sm align-self-center ms-1" (click)="twilioService.toggleMuteCall()">
            <svg-icon class="--standalone hover" [src]="twilioService.isCallMuted ? 'assets/images/call/mic-icon-off.svg' : 'assets/images/call/mic-icon.svg'"></svg-icon>
        </a>
    </ng-container>
    <a class="btn btn-styled btn-round --sm align-self-center ms-1" (click)="toggleAvailableAgents()" *ngIf="twilioService.callState !== twilioService.CallState.ONHOLD && (twilioService.isInboundCallRinging || twilioService.isOutboundCallGoingOn || twilioService.isInboundCallGoingOn)">
        <svg-icon class="--standalone" src="assets/images/call/redirect-call-icon.svg"></svg-icon>
    </a>
</ng-template>
